import { memo, useMemo } from 'react';
import { SwitchCase } from '@toss/react';
import { useTranslation } from 'next-i18next';
import { focusField } from '../focus/focusUtils';
import { useQuizFormField } from './hook/useQuizFormField';
import { QuizTypeSelector } from './QuizTypeSelector/QuizTypeSelector';
import { EssayBody } from './EssayBody';
import { MatchBody } from './MatchBody';
import { MultipleBody } from './MultipleBody';
import { OrderBody } from './OrderBody';
import { OXBody } from './OXBody';
import { QuizCard } from './QuizCardUI';
import { useQuizControl } from './QuizControlProvider';
import { SubjectiveBody } from './SubjectiveBody';
export const Body = () => {
  const {
    index
  } = useQuizControl();
  const [type, _] = useQuizFormField({
    field: 'type'
  });
  const leftSlot = useMemo(() => <QuizIndicator />, []);
  return <QuizCard.Content onClick={() => {
    focusField(`quizList.${index}.question`);
  }} data-sentry-element="unknown" data-sentry-component="Body" data-sentry-source-file="Body.tsx">
      <SwitchCase value={type} caseBy={{
      multiple: <MultipleBody leftSlot={leftSlot} />,
      subjective: <SubjectiveBody leftSlot={leftSlot} />,
      ox: <OXBody leftSlot={leftSlot} />,
      essay: <EssayBody leftSlot={leftSlot} />,
      match: <MatchBody leftSlot={leftSlot} />,
      order: <OrderBody leftSlot={leftSlot} />
    }} data-sentry-element="SwitchCase" data-sentry-source-file="Body.tsx" />
    </QuizCard.Content>;
};
const QuizIndicator = memo(() => {
  const {
    t
  } = useTranslation(['build']);
  const {
    index
  } = useQuizControl();
  return <div className="flex flex-row items-center gap-sm text-heading-sm-bold">
      {t('build:build.quiz.questionNumber', {
      number: index + 1
    })}
      <QuizTypeSelector />
    </div>;
});